import ResendConfirm from "./ForgotPasswordContainer";

export default ResendConfirm;
